const systemMessages = {
  PATIENT_WAS_REJECTED: 'PATIENT_WAS_REJECTED',
  ROOM_NOT_APPROVED: 'ROOM_NOT_APPROVED',
  USER_NOT_EXISTS_IN_THE_ROOM: 'USER_NOT_EXISTS_IN_THE_ROOM',
  ROOM_DISABLED_FOR_PATIENT: 'ROOM_DISABLED_FOR_PATIENT',
  SYSTEM_MESSAGE: {
    isSystemMessage: true,
    disable: true,
    text: 'Please wait while your message gets accepted.',
  },
  SYSTEM_MESSAGE_REJECTED: {
    isSystemMessage: true,
    disable: false,
    text: 'Your request was rejected, please contact your clinic for further assistance.',
  },
  SYSTEM_MESSAGE_DISABLED: {
    isSystemMessage: true,
    disable: false,
    text: 'The provider has closed the chat, if you need to send any more messages, please request to chat again by sending another message to the provider.',
  },
  PROVIDER_SYSTEM_MESSAGE_DISABLED: {
    isSystemMessage: true,
    disable: false,
    text: 'Patient was disabled.',
  },
  CA_SYSTEM_MESSAGE_REJECTED: {
    isSystemMessage: true,
    disable: false,
    text: "Patient's request was rejected",
  },
  CA_SYSTEM_MESSAGE: {
    isSystemMessage: true,
    disable: true,
    text: 'Patient waits until his message gets accepted.',
  },
};

export default systemMessages;
